import React from 'react';
import { CreditNoteHeader } from './CreditNoteHeader';
import { CreditNoteCustomer } from './CreditNoteCustomer';
import { CreditNoteLineItems } from './CreditNoteLineItems';
import { CreditNoteTotals } from './CreditNoteTotals';
import { CreditNoteFooter } from './CreditNoteFooter';
export function CreditNote() {
  const companyInfo = {
    name: 'MyTourix Travel Management',
    address: ['123 Orchard Road, #12-34', 'Singapore 238858'],
    phone: '+65 6789 1234',
    email: 'accounts@mytourix.com',
    gstRegNo: '201234567G'
  };
  const creditNoteInfo = {
    number: 'CN-2025-00045',
    issueDate: '20 January 2025',
    bookingRef: 'BKG-2025-TR-889',
    customerRef: 'IW00026770',
    staff: 'Sarah Chen'
  };
  const customerInfo = {
    name: 'LIM / LAI TEEN MS',
    contact: 'Tel: +65 9123 4567',
    attn: 'Accounts Department'
  };
  const lineItems = [{
    title: 'Air Ticket Refund – RF059476',
    details: [{
      label: 'Passenger Name',
      value: 'LIM / LAI TEEN MS'
    }, {
      label: 'Ticket No.',
      value: '081-3007415977'
    }, {
      label: 'Original Segment',
      value: 'SIN / MEL / SIN'
    }, {
      label: 'Departure Date',
      value: '24 AUG 2025'
    }, {
      label: 'Refund Segment',
      value: 'SIN / MEL / SIN'
    }, {
      label: 'Invoice No.',
      value: 'IW00026770'
    }, {
      label: 'Invoice Status',
      value: 'Settled'
    }, {
      label: 'Date',
      value: '05/07/25'
    }, {
      label: 'Less Refund Admin Fee',
      value: '85.00'
    }, {
      label: 'Inclusive GST @ 9%',
      value: '7.02'
    }],
    amount: 1250.5
  }, {
    title: 'Hotel Cancellation Refund',
    details: [{
      label: 'Hotel Name',
      value: 'Grand Hyatt Singapore'
    }, {
      label: 'Check-In Date',
      value: '15 FEB 2025'
    }, {
      label: 'Check-Out Date',
      value: '22 FEB 2025'
    }, {
      label: 'Room Type',
      value: 'Grand Deluxe King'
    }, {
      label: 'No. of Nights',
      value: '7'
    }, {
      label: 'Original Invoice',
      value: 'INV-2025-00234'
    }, {
      label: 'Cancellation Date',
      value: '10 JAN 2025'
    }, {
      label: 'Cancellation Fee',
      value: '150.00'
    }, {
      label: 'GST @ 9%',
      value: '13.50'
    }],
    amount: 1460.0
  }];
  const totals = {
    subtotal: 2485.5,
    tax: 225.0,
    totalCredit: 2710.5
  };
  return <div className="h-full overflow-auto bg-gradient-to-br from-neutral-50 to-neutral-100 p-6" data-id="element-176">
      <div className="w-[210mm] min-h-[297mm] max-h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col" data-id="element-177">
        <CreditNoteHeader company={companyInfo} creditNote={creditNoteInfo} data-id="element-178" />
        <CreditNoteCustomer customer={customerInfo} data-id="element-179" />
        <div className="flex-1 overflow-hidden" data-id="element-180">
          <CreditNoteLineItems items={lineItems} data-id="element-181" />
          <CreditNoteTotals {...totals} data-id="element-182" />
        </div>
        <CreditNoteFooter preparedBy="Sarah Chen" data-id="element-183" />
      </div>
    </div>;
}